import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import SideMenu from '../../components/sandbox/SideMenu';
import TopHeader from '../../components/sandbox/TopHeader';
import NoPermission from './nopermission/NoPermission';

//css
import './NewsSandBox.css';
//antd
import {Layout} from 'antd';
// 导入的页面组件
import SocietyInformation from './society/SocietyInformation';
import CorporationInformation from './society/CorporationInformation';
import ResearcherInformation from './society/ResearcherInformation';
import EmployeeInformation from './society/EmployeeInformation';
import SocietyOffice from './society/SocietyOffice';
import SocietyRecognition from './society/SocietyRecognition';
import YearlyInspection from './society/YearlyInspection';
import KeyActivities from './society/KeyActivities';
import OtherActivities from './society/OtherActivities';
import MeetingDelegate from './society/MeetingDelegate';
import ChangeRelationship from './society/ChangeRelationship';
import LogoutRelationship from './society/LogoutRelationship';
import EssentialInformation from './base/EssentialInformation';
import GroupBranchParties from './base/GroupBranchParties';
import GroupBranchMembers from './base/GroupBranchMembers';
import BaseRecognition from './base/BaseRecognition';
import BaseOffice from './base/BaseOffice';
import BranchActivities from './base/BranchActivities';
import PartyActivities from './base/PartyActivities';
import EvaluateInformation from './base/EvaluateInformation';
import MeetingNotice from './system/MeetingNotice';
import PolicyRegulations from './system/PolicyRegulations';
import InformationDelivery from './system/InformationDelivery';
import ChangePassword from './private/ChangePassword';
import Users from './private/Users';
import AddResearcherInformation from './society/AddResearcherInformation';
import AddEmployeeInformation from './society/AddEmployeeInformation';
import AddSocietyRecognition from './society/AddSocietyRecognition';
import AddYearlyInspection from './society/AddYearlyInspection';
import AddKeyActivity from './society/AddKeyActivity';
import AddOtherActivity from './society/AddOtherActivity';
import AddMeetingDelegate from './society/AddMeetingDelegate';
import AddBranchMembers from './base/AddBranchMembers';
import AddBaseRecognition from './base/AddBaseRecognition';
import AddBranchActivity from './base/AddBranchActivity';
import AddPartyActivity from './base/AddPartyActivity';
import AddEvaluateInformation from './base/AddEvaluateInformation';
import MeetingDetail from './system/MeetingDetail';
import AddGroupBranchParties from './base/AddGroupBranchParties';
import CustomTabs from './common/CustomTabs';
import InformationDetail from './system/InformationDetail';
import PolicyDetail from './system/PolicyDetail';
import MemberPersonal from './society/MemberPersonal';
import AddMemberPersonal from './society/AddMemberPersonal';
import MemberCompany from './society/MemberCompany';
import AddMemberCompany from './society/AddMemberCompany';
import ChangeOrganization from './society/ChangeOrganization';
import AddMeetingDetail from './system/AddMeetingDetail';
import HomeComponent from './home/Home';
import MeetingNoticeAdmin from './system/MeetingNoticeAdmin';
import AddMeetingNotice from './system/AddMeetingNotice';
import MeetingDetailAdmin from './system/MeetingDetailAdmin';
import PolicyRegulationsAdmin from './system/PolicyRegulationsAdmin';
import AddPolicyRegulation from './system/AddPolicyRegulation';
import InformationDeliveryAdmin from './system/InformationDeliveryAdmin';
import AddInformation from './system/AddInformation';
import BasicInformationAdmin from './party/BasicInformationAdmin';
import SocietyInformationAdmin from './society/SocietyInformationAdmin';
import PartyOfficeAdmin from './party/PartyOfficeAdmin';
import PartyMembersAdmin from './party/PartyMembersAdmin';
import AddPartyMember from './party/AddPartyMember';
import AddSocietyInformation from './society/AddSocietyInformation';
import YearlyInspectionAdmin from './society/YearlyInspectionAdmin';
import DetailYearlyInspection from './society/DetailYearlyInspection';
import SocietyRecognitionAdmin from './society/SocietyRecognitionAdmin';
import DetailSocietyRecognition from './society/DetailSocietyRecognition';
import KeyActivitiesAdmin from './society/KeyActivitiesAdmin';
import DetailKeyActivity from './society/DetailKeyActivity';
import OtherActivitiesAdmin from './society/OtherActivitiesAdmin';
import DetailOtherActivity from './society/DetailOtherActivity';
import MeetingDelegateAdmin from './society/MeetingDelegateAdmin';
import EssentialInformationAdmin from './base/EssentialInformationAdmin';
import BaseRecognitionAdmin from './base/BaseRecognitionAdmin';
import DetailBaseRecognition from './base/DetailBaseRecognition';
import BranchActivitiesAdmin from './base/BranchActivitiesAdmin';
import DetailBranchActivity from './base/DetailBranchActivity';
import PartyActivitiesAdmin from './base/PartyActivitiesAdmin';
import DetailPartyActivity from './base/DetailPartyActivity';
import EvaluateInformationAdmin from './base/EvaluateInformationAdmin';
import DetailEvaluateInformation from './base/DetailEvaluateInformation';
import ChangeUserName from './private/ChangeUserName';
import ChangeSocial from './society/ChangeSocial';
import LogoutSocial from './society/LogoutSocial';
import AddUser from './private/AddUser';
import EditUser from './private/EditUser';
import YearlyReport from './society/YearlyReport';
import YearlyReportAdmin from './society/YearlyReportAdmin';
import AddYearlyReport from './society/AddYearlyReport';
import DetailYearlyReport from './society/DetailYearlyReport';
import AddScienceBranchParties from './base/AddScienceBranchParties';
import ScienceBranchParties from './base/ScienceBranchParties';
import ScienceBranchMembers from './base/ScienceBranchMembers';

const {Content} = Layout;

export default function NewsSandBox() {
	return (
		<Layout>
			<TopHeader/>
			<Layout className="site-layout">
				<SideMenu/>
				<Content
					className="site-layout-background"
					style={{
						margin: '24px 16px',
						padding: 24,
						minHeight: 280,
						overflow: 'auto',
					}}
				>
					<CustomTabs/>
					<Switch>
						<Route path="/home" component={HomeComponent}/>
						<Route path="/party/basic-information-admin" component={BasicInformationAdmin}/>
						<Route path="/party/party-members-admin" exact={true} component={PartyMembersAdmin}/>
						<Route path="/party/party-members-admin/add" component={AddPartyMember}/>
						<Route path="/party/party-members-admin/edit" component={AddPartyMember}/>
						<Route path="/party/party-office-admin" component={PartyOfficeAdmin}/>

						<Route path="/society/society-information" exact={true} component={SocietyInformation}/>
						<Route path="/society/society-information-admin" exact={true}
							   component={SocietyInformationAdmin}/>
						<Route path="/society/society-information-admin/edit" component={AddSocietyInformation}/>

						<Route path="/society/corporation-information" component={CorporationInformation}/>
						<Route path="/society/researcher-information" exact component={ResearcherInformation}/>
						<Route path="/society/researcher-information/add" component={AddResearcherInformation}/>
						<Route path="/society/researcher-information/edit" component={AddResearcherInformation}/>
						<Route path="/society/employee-information" exact component={EmployeeInformation}/>
						<Route path="/society/employee-information/add" component={AddEmployeeInformation}/>
						<Route path="/society/employee-information/edit" component={AddEmployeeInformation}/>

						<Route path="/society/member-personal" exact component={MemberPersonal}/>
						<Route path="/society/member-personal/add" component={AddMemberPersonal}/>
						<Route path="/society/member-personal/edit" component={AddMemberPersonal}/>
						<Route path="/society/member-company" exact component={MemberCompany}/>
						<Route path="/society/member-company/add" component={AddMemberCompany}/>
						<Route path="/society/member-company/edit" component={AddMemberCompany}/>

						<Route path="/society/society-office" component={SocietyOffice}/>
						<Route path="/society/society-recognition" exact component={SocietyRecognition}/>
						<Route path="/society/society-recognition/add" component={AddSocietyRecognition}/>
						<Route path="/society/society-recognition/edit" component={AddSocietyRecognition}/>
						<Route path="/society/society-recognition-admin" exact component={SocietyRecognitionAdmin}/>
						<Route path="/society/society-recognition-admin/detail" component={DetailSocietyRecognition}/>

						<Route path="/society/yearly-inspection" exact component={YearlyInspection}/>
						<Route path="/society/yearly-inspection/add" component={AddYearlyInspection}/>
						<Route path="/society/yearly-inspection/edit" component={AddYearlyInspection}/>
						<Route path="/society/yearly-inspection-admin" exact component={YearlyInspectionAdmin}/>
						<Route path="/society/yearly-inspection-admin/detail" component={DetailYearlyInspection}/>

						<Route path="/society/yearly-report" exact component={YearlyReport}/>
						<Route path="/society/yearly-report/add" component={AddYearlyReport}/>
						<Route path="/society/yearly-report/edit" component={AddYearlyReport}/>
						<Route path="/society/yearly-report-admin" exact component={YearlyReportAdmin}/>
						<Route path="/society/yearly-report-admin/detail" component={DetailYearlyReport}/>

						<Route path="/society/meeting-delegate" exact component={MeetingDelegate}/>
						<Route path="/society/meeting-delegate-admin" exact component={MeetingDelegateAdmin}/>
						<Route path="/society/meeting-delegate/add" component={AddMeetingDelegate}/>
						<Route path="/society/meeting-delegate/edit" component={AddMeetingDelegate}/>
						<Route path="/society/change-organization" component={ChangeOrganization}/>
						<Route path="/society/change-social" component={ChangeSocial}/>
						<Route path="/society/logout-social" component={LogoutSocial}/>
						<Route path="/society/change-relationship" component={ChangeRelationship}/>
						<Route path="/society/logout-relationship" component={LogoutRelationship}/>


						<Route path="/activity/key-activity" exact component={KeyActivities}/>
						<Route path="/activity/key-activity/add" component={AddKeyActivity}/>
						<Route path="/activity/key-activity/edit" component={AddKeyActivity}/>
						<Route path="/activity/key-activity-admin" exact component={KeyActivitiesAdmin}/>
						<Route path="/activity/key-activity-admin/detail" component={DetailKeyActivity}/>

						<Route path="/activity/other-activity" exact component={OtherActivities}/>
						<Route path="/activity/other-activity/add" component={AddOtherActivity}/>
						<Route path="/activity/other-activity/edit" component={AddOtherActivity}/>
						<Route path="/activity/other-activity-admin" exact component={OtherActivitiesAdmin}/>
						<Route path="/activity/other-activity-admin/detail" component={DetailOtherActivity}/>

						<Route path="/activity/branch-activities" exact component={BranchActivities}/>
						<Route path="/activity/branch-activities/add" component={AddBranchActivity}/>
						<Route path="/activity/branch-activities/edit" component={AddBranchActivity}/>
						<Route path="/activity/branch-activities-admin" exact component={BranchActivitiesAdmin}/>
						<Route path="/activity/branch-activities-admin/detail" exact component={DetailBranchActivity}/>

						<Route path="/activity/party-activities" exact component={PartyActivities}/>
						<Route path="/activity/party-activities/add" component={AddPartyActivity}/>
						<Route path="/activity/party-activities/edit" component={AddPartyActivity}/>
						<Route path="/activity/party-activities-admin" exact component={PartyActivitiesAdmin}/>
						<Route path="/activity/party-activities-admin/detail" exact component={DetailPartyActivity}/>


						<Route path="/base/essential-information" exact={true} component={EssentialInformation}/>
						<Route path="/base/essential-information-admin" exact={true}
							   component={EssentialInformationAdmin}/>

						<Route path="/base/branch-parties-group" exact component={GroupBranchParties}/>
						<Route path="/base/branch-parties-group/edit" component={AddGroupBranchParties}/>
						<Route path="/base/branch-parties-science" exact component={ScienceBranchParties}/>
						<Route path="/base/branch-parties-science/edit" component={AddScienceBranchParties}/>
						<Route path="/base/branch-members-group" exact component={GroupBranchMembers}/>
						<Route path="/base/branch-members-group/add" component={AddBranchMembers}/>
						<Route path="/base/branch-members-group/edit" component={AddBranchMembers}/>
						<Route path="/base/branch-members-science" exact component={ScienceBranchMembers}/>
						<Route path="/base/branch-members-science/add" component={AddBranchMembers}/>
						<Route path="/base/branch-members-science/edit" component={AddBranchMembers}/>

						<Route path="/base/base-office" component={BaseOffice}/>
						<Route path="/base/base-recognition" exact component={BaseRecognition}/>
						<Route path="/base/base-recognition/add" component={AddBaseRecognition}/>
						<Route path="/base/base-recognition/edit" component={AddBaseRecognition}/>
						<Route path="/base/base-recognition-admin" exact component={BaseRecognitionAdmin}/>
						<Route path="/base/base-recognition-admin/detail" component={DetailBaseRecognition}/>

						<Route path="/base/evaluate-information" exact component={EvaluateInformation}/>
						<Route path="/base/evaluate-information/add" component={AddEvaluateInformation}/>
						<Route path="/base/evaluate-information/edit" component={AddEvaluateInformation}/>
						<Route path="/base/evaluate-information-admin" exact component={EvaluateInformationAdmin}/>
						<Route path="/base/evaluate-information-admin/detail" exact
							   component={DetailEvaluateInformation}/>

						<Route path="/system/meeting-notice" exact component={MeetingNotice}/>
						<Route path="/system/meeting-notice/:id" exact component={MeetingDetail}/>
						<Route path="/system/meeting-notice/:id/edit" component={AddMeetingDetail}/>

						<Route path="/system/meeting-notice-admin" exact component={MeetingNoticeAdmin}/>
						<Route path="/system/meeting-notice-admin/add" component={AddMeetingNotice}/>
						<Route path="/system/meeting-notice-admin/edit" component={AddMeetingNotice}/>
						<Route path="/system/meeting-notice-admin/:id" exact component={MeetingDetailAdmin}/>

						<Route path="/system/policy-regulations" exact component={PolicyRegulations}/>
						<Route path="/system/policy-regulations/:id" component={PolicyDetail}/>
						<Route path="/system/policy-regulations-admin" exact component={PolicyRegulationsAdmin}/>
						<Route path="/system/policy-regulations-admin/add" component={AddPolicyRegulation}/>
						<Route path="/system/policy-regulations-admin/edit" component={AddPolicyRegulation}/>
						<Route path="/system/policy-regulations-admin/:id" exact component={PolicyDetail}/>

						<Route path="/system/information-delivery" exact component={InformationDelivery}/>
						<Route path="/system/information-delivery/:id" exact component={InformationDetail}/>
						<Route path="/system/information-delivery-admin" exact component={InformationDeliveryAdmin}/>
						<Route path="/system/information-delivery-admin/add" component={AddInformation}/>
						<Route path="/system/information-delivery-admin/edit" component={AddInformation}/>
						<Route path="/system/information-delivery-admin/:id" exact component={InformationDetail}/>

						<Route path="/private/change-password" component={ChangePassword}/>
						<Route path="/private/change-password-admin" component={ChangePassword}/>
						<Route path="/private/users" exact component={Users}/>
						<Route path="/private/users/edit" component={EditUser}/>
						<Route path="/private/users/changeName" component={ChangeUserName}/>
						<Route path="/private/users/add" component={AddUser}/>

						<Redirect from="/" to="/login" exact/>
						<Route path="*" component={NoPermission}/>
					</Switch>
				</Content>
			</Layout>
		</Layout>
	);
}
